// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ugdKc","field":"styles_field__NGJse","fieldCol":"styles_fieldCol__2aDN5","diffCol":"styles_diffCol__2aGNp","diff":"styles_diff__rsVYB"};